<template>
  <div>
    <el-button type="primary" @click="showQRCode">二维码</el-button>
    <el-dialog :visible.sync="dialogVisible" title="二维码" append-to-body>
      <div ref="qrcodeContainer" style="text-align: center;">
        <vue-qrcode :value="url" tag="svg" :options="{ width: 300 }" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="printQRCode">打印二维码</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VueQrcode from '@chenfengyuan/vue-qrcode';

@Component({
  components: { VueQrcode }
})
export default class QRCode extends Vue {
  @Prop(String) url;

  dialogVisible = false

  showQRCode() {
    this.dialogVisible = true
  }

  printQRCode() {
    const printContent = this.$refs.qrcodeContainer.innerHTML;
    let newWin = window.open('', 'Print-Window');
    newWin.document.open();
    newWin.document.write(`
      <html>
        <head>
          <style>
            @page {
              size: 200mm 200mm;
            }
            body {
              margin: 0;
              padding: 0;
              width: 2cm;
              height: 2cm;
            }
            svg {
              width: 200mm;
              height: 200mm;
            }
          </style>
        </head>
        <body onload="window.print()">
          ${printContent}
        </body>
      </html>
    `);
    newWin.document.close();
    setTimeout(() => newWin.close(), 10);
  }
}
</script>
